<div *ngIf="isOpen" class="fixed inset-0 z-[60] flex items-center justify-center p-4">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" (click)="onClose()"></div>

  <!-- Modal Content -->
  <div class="relative w-full max-w-6xl bg-white rounded-3xl shadow-2xl overflow-hidden animate-slide-up flex flex-col max-h-[90vh]">
    <!-- Header -->
    <div class="p-6 border-b border-slate-100 flex justify-between items-center bg-white sticky top-0 z-10">
      <div>
        <h3 class="text-xl font-black text-slate-800 uppercase tracking-widest">
          {{ healthPlanName || ('health_plan_procedures_title' | translate) }}
        </h3>
        <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">{{ 'health_plan_procedures_subtitle' | translate }}</p>
      </div>
      <button (click)="onClose()" class="p-2 hover:bg-slate-50 rounded-xl transition-colors text-slate-400 hover:text-slate-600">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto p-6">
      <div class="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4 mb-6">
        <div class="flex-1 max-w-md">
          <p-iconField iconPosition="left">
            <p-inputIcon styleClass="pi pi-search text-slate-400" />
            <input type="text" pInputText placeholder="{{ 'health_plan_procedures_search_placeholder' | translate }}"
              class="w-full !bg-white !border-slate-200 !rounded-xl !text-sm focus:!ring-2 focus:!ring-primary/10 focus:!border-primary !shadow-sm transition-all"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearch($event)"
              (keyup.enter)="onSearch(searchText)">
          </p-iconField>
        </div>

        <app-button *hasPermission="'Procedimentos:edit'" label="{{ 'health_plan_procedures_import_button' | translate }}"
          icon="pi pi-upload" variant="primary" (onClick)="openImport()">
        </app-button>
      </div>

      <app-prime-table [columns]="columns" [data]="procedures" [loading]="loading" [totalRecords]="totalRecords"
        [rows]="rows" [first]="first" [paginator]="true" [lazy]="true" [templates]="templates"
        (onLazyLoad)="onPageChange($event)">
      </app-prime-table>
    </div>
  </div>
</div>

<!-- Templates -->
<ng-template #statusTemplate let-row>
  <span class="px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest shadow-sm" [ngClass]="{
      'status-success': row.active === true,
      'bg-slate-100 text-slate-400 border border-slate-200': row.active !== true
    }">
    {{ (row.active === true ? 'status_active' : 'status_inactive') | translate }}
  </span>
</ng-template>

<ng-template #actionsTemplate let-row>
  <app-dropdown *hasPermission="'Procedimentos:edit'" [menuClass]="'w-48'">
    <ng-template #trigger>
      <div class="flex justify-center" (click)="toggleMenu(row)">
        <app-button icon="pi pi-ellipsis-v" variant="ghost" [styleClass]="'!p-0'"></app-button>
      </div>
    </ng-template>
    <ng-template #content>
      <div class="flex flex-col py-1">
        <button *ngFor="let mItem of actionItems" (click)="mItem.command?.({})"
          class="w-full text-left px-4 py-3 text-xs font-black text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors uppercase tracking-widest group/item">
          <i [class]="mItem.icon" class="text-primary text-base group-hover/item:scale-110 transition-transform"></i>
          {{ mItem.label }}
        </button>
      </div>
    </ng-template>
  </app-dropdown>
</ng-template>

<!-- Sub-modals -->
<app-import-health-plan-procedures-modal *ngIf="showImportModal" [branchId]="branchId" [healthPlanId]="healthPlanId"
  (close)="onImportClose($event)">
</app-import-health-plan-procedures-modal>

<app-edit-health-plan-procedure-modal [isOpen]="showEditModal" [procedure]="editingProcedure"
  (close)="onEditClose()" (saved)="onEditSaved()">
</app-edit-health-plan-procedure-modal>

<!-- Delete confirm -->
<div *ngIf="deletingProcedure" (click)="cancelDelete()"
  class="fixed inset-0 z-[80] w-full h-full flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
  <div (click)="$event.stopPropagation()" class="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-7 animate-slide-up">
    <div class="w-12 h-12 rounded-full bg-danger/10 flex items-center justify-center mb-4">
      <i class="pi pi-exclamation-triangle text-danger text-lg"></i>
    </div>
    <h3 class="text-base font-black text-slate-800 mb-2">{{ 'health_plan_procedures_delete_confirm_title' | translate }}</h3>
    <p class="text-sm text-slate-500 mb-6">{{ deletingProcedure.description }}</p>
    <div class="flex justify-end gap-3">
      <app-button [label]="'button_cancel' | translate" variant="ghost" (onClick)="cancelDelete()"
        styleClass="!text-[10px] !font-bold !uppercase !tracking-widest !px-6 !py-2">
      </app-button>
      <app-button [label]="'action_delete' | translate" [loading]="deleting" (onClick)="deleteConfirmed()"
        styleClass="!bg-danger !border-danger !text-[10px] !font-black !uppercase !tracking-widest !px-8 !py-2.5 !rounded-xl">
      </app-button>
    </div>
  </div>
</div>
